<template>
  <div>
    <portlet :icon="'fad fa-question'"
             :title="$t('reasonTrees.createReasonTree')"
             :actionsBlock="true"
    >
      <div slot="actionsBlock">
        <back-button :link="'reason-trees'"/>
      </div>
      <template slot="portletBody">
        <div class="row mobile-grid">
          <div class="form-group mobile-col col-3">
            <label for="reasonTree-name">{{ $t('reasonTrees.table.name') }}</label>
            <input id="reasonTree-name"
                   name="reasonTree-name"
                   type="text"
                   class="form-control"
                   v-model.trim="reasonTree.name"/>
          </div>
          <div class="form-group mobile-col col-2">
            <label for="reasonTree-defaultLocale">{{ $t('reasonTrees.defaultLocale') }}
              <i
                class="far fa-info-circle align-right" @click="showDefaultLanguageHelp()"
                style=" cursor:pointer"></i></label>
            <select name="reasonTree-defaultLocale" id="reasonTree-defaultLocale" class="form-control"
                    v-model="reasonTree.defaultLocale">
              <option :key="'l-'+language"
                      v-for="language in getAvailableLocales"
                      :value="language"
              >
                {{ $t('languages.' + language) }}
              </option>
            </select>

          </div>
          <div class="form-group mobile-col col-2">
            <label for="reasonTree-jobdowntime">{{ $t('reasonTrees.table.job') }},{{ $t('reasonTrees.table.downtime') }} {{ $t('ifttt.or').toLowerCase().trim() }} {{ $t('reasonTrees.defectTypes.defect') }}</label>
            <select name="reasonTree-jobdowntime" id="reasonTree-jobdowntime" class="form-control"
                    v-model="reasonTree.type">
              <option :value="undefined" disabled selected>{{ $t('ui.select') }} {{ $t('workflows.table.type').toLowerCase().trim() }}...</option>
              <option :value="'job'">{{ $t('reasonTrees.table.job') }}</option>
              <option :value="'defects'">{{ $t('reasonTrees.table.defects') }}</option>
              <option v-show="getConfig && getConfig.downTime && getConfig.downTime.enabled" :value="'downtime'">
                {{ $t('reasonTrees.table.downtime') }}
              </option>
            </select>

          </div>
          <div class="form-group mobile-col col-2" v-show="getCompanyDepartments.length">
            <label for="reasonTree-department">{{ $t('workflows.table.department') }}</label>
            <select name="reasonTree-department" id="reasonTree-department" class="form-control"
                    v-model="reasonTree.department">
              <option :value="undefined" disabled>{{ $t('ui.select') }} {{ $t('workflows.table.department').toLowerCase().trim() }}...</option>
              <option :key="idx+1" :value="department" v-for="(department,idx) in getCompanyDepartments">
                {{ department }}
              </option>
            </select>
          </div>

          <div class="form-group  mobile-col col-2"
               v-if="reasonTree.type === 'downtime' || reasonTree.type =='defects' ">

            <label for="">{{ $t('ui.select') }} {{ $t('products.workflows.title').toLowerCase().trim() }}</label>
            <div v-if="!reasonTree.department && !reasonTree.type">
              <span> {{ $t('ui.select') }} {{ $t('workflows.table.department').toLowerCase().trim() }}(s) {{ $t('ifttt.and').toLowerCase().trim() }} {{ $t('workflowInterface.orderSequence').toLowerCase().trim() }}/{{ $t('reasonTrees.table.downtime').toLowerCase().trim() }} {{ $t('reasonTrees.first') }}...</span>
            </div>
            <div v-else>
              <div :key='idx+1' class="custom-control custom-checkbox "
                   v-for="(wf,idx) in getWorkflowsFromDepartment(reasonTree.department)">
                <input v-model="reasonTree.workflows"
                       :value="wf.id"
                       type="checkbox"
                       :disabled="checkIfWorkflowUsedElseWhere(wf.id)"
                       :id="'wf' + idx"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'wf' + idx">
                  <span>{{ wf.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </portlet>
    <div class="row">
      <div class="col-6">
        <portlet :icon="'fad fa-edit'"
                 :title="$t('reasonTrees.edit.title')"
                 :actionsBlock="true"
                 :fullheight="true"
        >
          <div slot="actionsBlock">
            <!--            <back-button :link="'reason-trees'"/>-->
            <button @click="addRootReason" class="ml-3 btn btn-primary"
                    :class="!reasonTree.children.length ? 'pulse' : ''">{{ $t('reasonTrees.addRootLevel') }}
            </button>
          </div>

          <template slot="portletBody">

            <Tree

                :triggerClass="'handle'"
                :value="reasonTree.children"
                :indent="20"
                @drop="nodesMoved"
                :foldAllAfterMounted="true"
                ref="TREE"
            >
              <div class="tree-node-slot" slot-scope="{node, index, path, tree}">
                <div @click="selectedNodePath=path;showNode(node, index, path, tree)"
                     :class="treeIsActive(path,selectedReason ? selectedReason.path : []) " style="padding:5px;">
                  <i class="fa fa-align-justify handle mr-2"></i>
                  <b @click="tree.toggleFold(node, path)" v-if="node.children.length"> {{
                      node.$folded ? '+' : '-'
                    }}
                  </b>

                  <div @click="showNode(node, index, path, tree), tree.unfold(node, path)"
                       style="width:90%;display:inline-block;"> {{
                      node.name
                    }}
                  </div>
                </div>


              </div>
              <button @click="addRootReason" class="btn btn-primary">{{ $t('reasonTrees.addRootLevelReason') }}</button>


            </Tree>
          </template>
        </portlet>
      </div>
      <div class="col-6">
        <portlet :icon="'fad fa-level-down'"
                 :title="!selectedReason ? $t('reasonTrees.noReasonSelected')    :'L'+selectedNodePath.length+' ' + selectedReason.data.name "
                 :actionsBlock="true"
                 :fullheight="true"

        >
          <div slot="actionsBlock">
            <button v-if="selectedNodePath.length < 3 && selectedReason && reasonTree.type != 'defects' "
                    @click="addReasonLevel()"
                    class="btn btn-primary mr-3">
              {{ $t('reasonTrees.add.addReasonLevel', [selectedNodePath.length]) }}
            </button>
            <button
                v-if=selectedReason @click="deleteReasonTree(selectedReason)"
                class="btn btn-danger">{{ $t('ui.delete') }} {{ $t('jobs.detail.reasons.reason').toLowerCase().trim() }}
            </button>
          </div>
          <template slot="portletBody">

            <div v-if="selectedReason">

              <TabBar @tabClicked="activeKey = $event" :buttons="buttons" :defaultSelectedIndex="0"></TabBar>
              <div v-show="activeKey == 'settings'">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="">{{ $t('jobs.reasons.reason') }} {{ $t('reasonTrees.table.name').toLowerCase().trim() }}</label>
                      <input class="form-control" type="text" v-model="selectedReason.data.name">
                    </div>

                  </div>
                  <div class="col-12" v-if="selectedReason.level === 1 && reasonTree.type  == 'defects' ">
                    <label for="incrementValue"> {{ $t('reasonTrees.defects.incrementValue') }}
                    </label>
                    <input type=number name="incrementValue" class="form-control" id="incrementValue"
                           v-model="selectedReason.data.incrementValue">

                  </div>
                  <div class="col-12" v-if="selectedReason.level === 1 && reasonTree.type != 'defects' ">
                    <label for="type-planned">{{ $t('ui.type') }}</label>
                    <select name="type-planned" class="form-control" id="type-planned"
                            v-model="selectedReason.data.reasonType">
                      <option value="out-planned">{{ $t('reasonTrees.plannedTypes.out-planned') }}</option>
                      <option value="unplanned">{{ $t('reasonTrees.plannedTypes.unplanned') }}</option>
                      <option value="planned">{{ $t('reasonTrees.plannedTypes.planned') }}</option>
                    </select>
                  </div>
                  <div class="col-12">
                    <div class="form-group" v-if=" reasonTree.type != 'defects'">
                      <label>{{ $t('reasonTrees.excludeFromProductivityLabel') }}</label>
                      <div class="custom-control custom-checkbox">
                        <input v-model="selectedReason.data.excludeFromProductivity"
                               type="checkbox"
                               :value="true"
                               :id="'excludeFromProductivity'"
                               class="custom-control-input"
                        >
                        <label class="custom-control-label" :for="'excludeFromProductivity'">
              <span>
               {{ $t('reasonTrees.excludeFromProductivityInfo') }}
              </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-12"
                       v-if="!selectedReason.data.children.length && selectedReason.rootLevel.reasonType === 'planned' ">
                    <label for="reason-norm">{{ $t('reasonTrees.norm') }} <small class="text-right">{{ $t('reasonTrees.inMinutes') }}</small></label>
                    <input type="number" id="reason-norm" class="form-control" min=1
                           v-model.number="selectedReason.data.norm">
                  </div>
                  <div class="col-12">
                    <template
                        v-if=" selectedReason && selectedReason.data.children.length < 1  && getConfig.downTime.machineErrorCodes">
                      <h3>{{ $t('reasonTrees.machineError') }}</h3>
                      <p>{{ $t('reasonTrees.MachineErrorFillIn') }}</p>
                      <textarea v-model=selectedReason.data.machineErrorCodes name="" id="" class="form-control"
                                cols="30"
                                rows="10"/>

                    </template>
                  </div>


                </div>
              </div>

              <div v-show="activeKey == 'translations'">
                <div class="col-12">

                  <div class="form-group">
                    <!--                    <div :key=locale v-for="locale in availableLocales">-->
                    <div :key=locale v-for="locale in getAvailableLocales">

                      <label :for="'locale-'+locale">{{ $t('languages.' + locale) }}</label>
                      <textarea
                          :disabled="locale === reasonTree.defaultLocale"
                          class="form-control"
                          :id="'locale-'+locale" v-model="selectedReason.data.translations[locale]">
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row" v-if="selectedReason">
                <div class="col-12 text-right   pr-5 pl-5 pt-4 pb-4">
                  <button @click="saveReasonTree(false)" class="btn btn-primary ml-3" type="button">
                    {{ $t('ui.save') }}
                  </button>
                </div>
              </div>
            </div>
          </template>

        </portlet>

      </div>
    </div>


    <div class="col-12 text-right bg-white m-box-shadow pr-5 pl-5 pt-4 pb-4">
      <router-link :to="{name:'reason-trees'}" class="btn btn-cancel">
        {{ $t('ui.cancel') }}
      </router-link>
      <button v-show="shouldShowSaveButton" @click="createReasonTree()" class="btn btn-primary ml-3" type="button">
        {{ $t('ui.create') }}
      </button>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {reasonTree} from '../../mixins/reasonTree/reasonTree';
import {reasonTreePrevent} from '../../mixins/reasonTree/reasonTreePrevent';
import draggable from 'vuedraggable';
import DraggableItem from '../../components/reasonTrees/draggableReason.vue';
import {Draggable, Fold, Tree} from "he-tree-vue";
import 'he-tree-vue/dist/he-tree-vue.css'
import TabBar from "@/components/TabBar.vue";

//@vuese
//@group ReasonTrees
export default {
  name: 'CreateReasonTree',
  components: {
    TabBar,
    DraggableItem,
    draggable,
    Tree: Tree.mixPlugins([Fold, Draggable]),

  },
  mixins: [reasonTree, reasonTreePrevent],
  data() {
    return {
      activeKey: 'settings',
      buttons: [
        {value: 'settings', label: this.$t('reasonTrees.settings')},
        {value: 'translations', label: this.$t('reasonTrees.translations')},
      ],
      selectedReason: null,
      selectedNodePath: [],
    }
  },
  computed: {
    availableLocales() {
      return _.filter(this.getAvailableLocales, locale => {
        return locale !== this.reasonTree.defaultLocale
      })
    },
    ...mapGetters(['getUserData', 'getAvailableLocales']),
    // ...mapGetters('userData', ['getMe']),
    ...mapGetters('users', [
      'getClaims',
      'getMe',
      'getLocalData'
    ]),
    ...mapGetters('company', [
      'getConfig',
      'getCompanyDepartments'
    ]),
    ...mapGetters('company', ['getCompanyDepartments']),
    ...mapGetters('workflows', ['getWorkflows', 'getWorkflow', 'getWorkflowsFromDepartment']),
    ...mapGetters('reasonTrees', [
      'getReasonTree', 'getReasonTrees'
    ]),
    shouldShowSaveButton() {
      return this.reasonTree.name && this.reasonTree.type && this.reasonTree.children.length > 0
    }
  },
  methods: {


    checkIfWorkflowUsedElseWhere(workflowId) {
      let reasonTreesWithSameType = _.filter(this.getReasonTrees, reasonTree => {
        return this.reasonTree.type === reasonTree.type && reasonTree.id !== this.reasonTree.id
      })

      let workflowIds = []
      _.each(reasonTreesWithSameType, reasonTree => {
        workflowIds = _.union(workflowIds, reasonTree.workflows)
      })
      return _.includes(workflowIds, workflowId)

    },
    /**
     * Save the reason Tree to Firebase and save the levels into a subcollection
     */
    createReasonTree() {
       this.reasonTree.companyId = this.getClaims.companyId;
      this.reasonTree.createdBy = this.getMe.displayName ? this.getMe.displayName : this.getMe.email;
  console.log(this.reasonTree)
       this.$store.dispatch('reasonTrees/insert', this.reasonTree)
          .then(() => {
            this.disableNavigation = false;
            this.$router.push({name: 'reason-trees'});
            this.swalToastSuccess(this.$t('reasonTrees.created'));
          })
          .catch(() => {
            this.$toasted.global.failedRequest();
          });
    },
    saveReasonTree(redirectBack) {
  n
      this.$store.dispatch('reasonTrees/set', this.reasonTree)
          .then(() => {
            this.disableNavigation = false;
            if (redirectBack) {
              this.$router.push({name: 'reason-trees'});
            }
            this.swalToastSuccess(this.$t('reasonTrees.saved'));
          })
          .catch(() => {
            this.$toasted.global.failedRequest();
          });
    }
  },
  watch: {

    'selectedReason': function (newV) {
      let type = this.selectedReason.rootLevel.reasonType

      if (type == 'out-planned') {
        this.selectedReason.data.excludeFromProductivity = true
      }
      if (!this.selectedReason.data.translations) {
        this.selectedReason.data.translations = {}
        this.selectedReason.data.translations[this.reasonTree.defaultLocale] = this.selectedReason.data.name

      }

    }
  },
  created() {
    // console.log(this.getMe)
    // this.reasonTree.defaultLocale = this.getMe.locale
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/scss/mobile/mobileSettings";

.align-left {
  text-align: left;

}

@media only screen and (max-device-width: $maxMobileWidth) {
  .mobile-grid {
    display: grid !important;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-column-gap: 0px;
    grid-row-gap: 12px;
  }

  .mobile-col {
    max-width: 100% !important;
  }
}

.pulse {
  background-color: #00adff;
  border-radius: 50%;
  position: relative;
  animation: animate 3s linear infinite
}

.tree-node-slot {
  cursor: pointer !important;
}


.he-tree .tree-node {
  padding: 0 !important;
}

.active-tree {
  color: White !important;
  background: #01c9ff;
  //padding:5px;
}

//.active-tree::after {
//  text-align: right;
//  color: #0a86a8;
//  font-family: "Font Awesome 5 Pro", sans-serif;
//  float: right;
//  content: "\f33a";
//
//}

.handle {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

@keyframes animate {
  0% {
    box-shadow: 0 0 0 0 rgb(0, 173, 255), 0 0 0 0 rgb(0, 173, 255);
  }

  40% {
    box-shadow: 0 0 0 10px rgba(255, 109, 74, 0), 0 0 0 0 rgb(0, 173, 255);
  }

  80% {
    box-shadow: 0 0 0 20px rgba(255, 109, 74, 0), 0 0 0 10px rgba(255, 109, 74, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 109, 74, 0), 0 0 0 10px rgba(255, 109, 74, 0);
  }
}
</style>

